import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import Post from './Post';

const SingleDreamPage = () => {
    const { dreamId } = useParams();
    const navigate = useNavigate();
    const [dream, setDream] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchDream = async () => {
            try {
                const dreamRef = doc(db, 'dreams', dreamId);
                const dreamDoc = await getDoc(dreamRef);

                if (!dreamDoc.exists()) {
                    setError('Dream not found');
                    return;
                }

                setDream({
                    id: dreamDoc.id,
                    ...dreamDoc.data()
                });
            } catch (err) {
                console.error('Error fetching dream:', err);
                setError('Failed to load dream');
            } finally {
                setLoading(false);
            }
        };

        fetchDream();
    }, [dreamId]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-screen gap-4">
                <p className="text-xl text-gray-600 dark:text-gray-300">{error}</p>
                <button
                    onClick={() => navigate('/feed')}
                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
                >
                    Return to Feed
                </button>
            </div>
        );
    }

    return (
        <div className="max-w-2xl mx-auto px-4 py-8">
            {dream && <Post post={dream} />}
        </div>
    );
};

export default SingleDreamPage;
